import React from 'react'
import styled from 'styled-components';
import { device } from "../device";

const ButtonWithArrow = styled.button`
    position: relative;

    align-items: center;
    display: flex;
    height: 32px;
    justify-content: center;
    margin-bottom: 48px;
    padding: 0 4px 0 18px;
    width: fit-content;

    background: transparent;
    color: var(--green1);
    border: 0;
    border: 1px solid var(--green1);
    border-radius: 24px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    line-height: 1px;
    outline: 0;
    transition: all .15s;
    &:hover {
        background: var(--green2);
        color: var(--brand);
    }
    @media ${device.lg} {
        // padding: 18px 6px 17px 18px;
        padding: 0 4px 0 18px;
    }
    span {
        display: inline-block;
        margin-right: 8px;
    }
`;

const ButtonWithIconArrowTransparent = ({children, onClick}) => {
    const arrIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0)">
            <rect width="24" height="24" rx="12" transform="matrix(-1 0 0 1 24 0)" fill="#5AE4AA"/>
            <path d="M19 11.6706L13.2702 6L12.0208 7.23657L15.6633 10.8173H5L5.01289 12.5256H15.6624L12.0208 16.1047L13.2702 17.3413L19 11.6706Z" fill="#242424"/>
            </g>
            <defs>
            <clipPath id="clip0">
            <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
            </clipPath>
            </defs>
        </svg>
        
        
        

    return (
        <ButtonWithArrow onClick={onClick}>
            <span>{children}</span>
            {arrIcon}
        </ButtonWithArrow>
    )
    
}

export default ButtonWithIconArrowTransparent;